import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as homeReducer from "containers/Home/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as setupReducer from "containers/Setup/reducer";
import * as marketReducer from "containers/Market/MarketReducer";
import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";
import * as deploymentsReducer from "containers/Deployments/reducer";

import Models from "components/Next/Models/Models";

const getId = (props) =>
  props && props.id
    ? props.id
    : props && props.match && props.match.params && props.match.params.id
      ? props.match.params.id
      : "new";

const getDatasetId = (props) =>
  props && props.datasetId
    ? props.datasetId
    : props && props.match && props.match.params && props.match.params.datasetId
      ? props.match.params.datasetId
      : "new";

const getBlueprintId = (props) =>
  props && props.blueprintId
    ? props.blueprintId
    : props && props.match && props.match.params && props.match.params.blueprintId
      ? props.match.params.blueprintId
      : undefined;

class ModelsContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { id } = this.props;

    return <Models {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);

  return {
    init: (id) => dispatch(nextModelsReducer.init(id)),
    handleBack: () => dispatch(nextModelsReducer.handleBack(id)),
    handleUpdate: (hex, node) => dispatch(nextModelsReducer.handleUpdate(id, hex, node)),
    updateSelectedHex: (hex, node) =>
      dispatch(nextModelsReducer.updateSelectedHex(id, hex, node, undefined, getBlueprintId(ownProps))),

    updateIsDeployOpen: (isOpen) => dispatch(nextModelsReducer.updateIsDeployOpen(id, isOpen)),

    updateActiveTab: (activeTab) => dispatch(nextReducer.updateActiveTab(id, activeTab)),

    deploy: (projectId) => dispatch(projectReducer.deploy(projectId, true)),

    viewConsultants: () => dispatch(marketReducer.viewConsultants()),
    updateIsCreateJob: (isCreateJob) => dispatch(marketReducer.updateIsCreateJob(isCreateJob, ownProps)),
    updateHireConsultant: (consultantId, isHire) => dispatch(marketReducer.updateHireConsultant(consultantId, isHire)),

    handleStartBreadcrumbs: (node, isAll, isRemove) =>
      dispatch(nextModelsReducer.handleStartBreadcrumbs(id, node, isAll, isRemove)),
    updateHoverNode: (hoverNode) => dispatch(nextModelsReducer.updateHoverNode(id, hoverNode)),
    applySetupStep: (node) => dispatch(nextModelsReducer.applySetupStep(id, node)),
    saveUpdateBlueprint: () => dispatch(nextModelsReducer.saveUpdateBlueprint(id))
  };
};
const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);
  const blueprintId = getBlueprintId(ownProps);
  const datasetId = nextReducer.getDatasetId(state, id);
  const projectId = nextReducer.getProjectId(state, id);

  const optimized = projectReducer.getOptimized(state, projectId);

  const runId = optimized && optimized.innerId !== undefined ? optimized.innerId : id;

  const businessConstraints = setupReducer.getBusinessConstraints(state, projectId, runId);
  const impliedBusinessConstraints = setupReducer.getImpliedBusinessConstraints(state, projectId, runId);

  return {
    id: id,
    blueprintId: blueprintId,
    datasetId: datasetId,
    projectId: projectId,
    runId: runId,

    nSetup: setupReducer.getSetup(state, "new"),

    optimized: projectReducer.getOptimized(state, projectId),
    segmentColor: projectReducer.getSegmentColor(state, projectId),

    deployment: deploymentsReducer.getProjectDeployment(state, projectId),

    hexSize: nextReducer.getHexSize(state, id),
    innerHexSize: nextReducer.getInnerHexSize(state, id),

    dataset: homeReducer.getDataset(state, datasetId),

    hexMap: nextModelsReducer.getHexMap(state, id),
    actionHexMap: nextModelsReducer.getActionHexMap(state, id),
    savedHexMap: nextModelsReducer.getSavedHexMap(state, id),
    selectedHex: nextModelsReducer.getSelectedHex(state, id),
    hasSetupChanged: nextModelsReducer.getHasSetupChanged(state, id),
    nodeAssign: nextModelsReducer.getNodeAssign(state, id),

    todos: nextModelsReducer.getTodos(state, id),

    isDeployOpen: nextModelsReducer.getIsDeployOpen(state, id),

    hasActions: nextModelsReducer.getHasActions(state, id),

    project: nextReducer.getActiveProject(state, id),
    oProject: nextReducer.getProject(state, id),

    isProjectLoading: nextModelsReducer.getIsProjectLoading(state, id),
    isCommentModal: nextModelsReducer.getIsCommentModal(state, id),
    isEditBlueprint: nextModelsReducer.getIsEditBlueprint(state, id),

    isLoading: nextModelsReducer.getIsLoading(state, id),

    consultants: marketReducer.getConsultantsArr(state),
    isContinuous: setupReducer.getIsContinuous(state, runId),
    modelGroups: projectReducer.getModelGroups(state, projectId),
    blueprintText: nextModelsReducer.getBlueprintText(state, id),
    businessConstraints: businessConstraints,
    impliedBusinessConstraints: impliedBusinessConstraints
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ModelsContainer);
